import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "app/auth/service";
import { Router, ActivatedRoute } from "@angular/router";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StockreceiveService } from 'app/_services/stockreceive.service';
import { PurchaseService } from 'app/_services/purchase.service';
import { log } from 'console';

@Component({
  selector: 'app-stockreceive',
  templateUrl: './stockreceive.component.html',
  styleUrls: ['./stockreceive.component.scss']
})
export class StockreceiveComponent implements OnInit {

  public stockList: any = [];
  public start: any = 0;
  public page: any = 0;

  public pageBasicText = 1;
  public collectionSize = 0;
  public lengths = 15;
  public loading = false;
  public progressMainTable: boolean = false;
  public isModelLoading: Boolean = true;
  public purchaseDetails: any;
  StatusLable: any;

  public newFormAdd: FormGroup;
  public newFormDate: FormGroup;
  public newFormFilter: FormGroup;
  public submitted = false;
  public purchaseId: any = 0;
  public type: any = 0;
  public error = "";
  public loadingFrm: boolean = false;
  public file: any = '';
  public exp_name: any = '';
  public vendorDropDown: any = [];

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private stockreceiveService: StockreceiveService,
    private PurchaseService: PurchaseService,
    private _authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private _toastrService: ToastrService,
    private http: HttpClient,
    private modalService: NgbModal,
    private _coreSidebarService: CoreSidebarService
  ) { }

  getvendorDropDown() {
    this.PurchaseService.getvendorDropDown().subscribe(
      data => {
        if (data.status) {
          this.vendorDropDown = data.vendor;
        }
      });
  }
  ngOnInit(): void {
    this.loading = true;
    this.getvendorDropDown();

    this.stocksList(this.start, this.lengths);
    this.newFormAdd = this._formBuilder.group({
      file: ["", Validators.required]
    });
    this.newFormDate = this._formBuilder.group({
      port_date: ["", Validators.required]
    });

    this.newFormFilter = this._formBuilder.group({
      start_date: [''],
      end_date: [''],
      vehicle_details: [''],
      vendor_id: [null],
    });
  }

  get f() {
    return this.newFormAdd.controls;
  }
  get fd() {
    return this.newFormDate.controls;
  }
  get fr() {
    return this.newFormFilter.controls;
  }
  onSubmit1() {
    this.submitted = true;
    this.loading = true;
    // this.toggleSidebar('new-sidebar1');
    this.stockList = [];
    // stop here if form is invalid
    if (this.newFormFilter.invalid) {
      console.log('error');
    }
    else {
      this.page = 0;
      this.pageBasicText = 1;

      const formdata = new FormData();
      formdata.append('start', "0");
      formdata.append('length', "15");

      if (this.fr.start_date.value !== null) {
        formdata.append('start_date', this.fr.start_date.value);
      }
      if (this.fr.end_date.value !== null) {
        formdata.append('end_date', this.fr.end_date.value);
      }
      if (this.fr.vendor_id.value != "") {
        formdata.append('vendor_id', this.fr.vendor_id.value);
      }
      if (this.fr.vehicle_details.value != "") {
        formdata.append('vehicle_details', this.fr.vehicle_details.value);
      }
      this.stockreceiveService.getData(formdata).subscribe(
        data => {
          this.loading = false;
          if (data.status) {
            this.stockList = data.data;
            this.collectionSize = data.recordsTotal;
          }
        },
        err => {
          if (err.error.error == 'Unauthenticated.') {
            this._authenticationService.logout();
            this._router.navigate(['/login']);
          }
        }
      );
    }
  }
  onSubmit2(){
    this.submitted = true;
    // stop here if form is invalid
    if (this.newFormDate.invalid) {
      this.newFormDate.markAllAsTouched();
    } else {
      this.loadingFrm = true;
      this.error = "";
      const { port_date} = this.newFormDate.controls;
      this.stockreceiveService.adddate(port_date.value,this.purchaseId
      ).subscribe(
        (data) => {
          this.loadingFrm = false;
          if (data.status) {
            this.purchaseId = 0;
            this.submitted = false;
            this.newFormDate.reset();
            this.toggleSidebar("new-sidebar-date");
            this._toastrService.success(data.message, "Success!", {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
            this.reloadList();
          } else {
            this.error = data.message;
          }
        },
        (err) => {
          if (err.error.error == "Unauthenticated.") {
            this._authenticationService.logout();
            this._router.navigate(["/login"]);
          }
        }
      );
    }
  }
  resetReport() {
    this.newFormFilter.reset();
    this.onSubmit1();
    this.onSubmit2();
  }
  toggleSidebar(name, id: number = 0, index: any = null): void {
    this.purchaseId = id;
    this.type = index;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  uploadFile(event: any, type: any) {
    if (type == 1) {
      this.file = event.target.files[0];
    }
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.newFormAdd.invalid) {
      console.log('error');
    }
    else {
      this.loadingFrm = true;
      const formdata = new FormData();
      formdata.append('file', this.file);
      formdata.append('id', this.purchaseId);
      formdata.append('type', this.type);

      this.PurchaseService.addfile(formdata).subscribe(
        data => {
          this.loadingFrm = false;
          if (data.status) {
            this.submitted = false;
            this.toggleSidebar('new-sidebar');
            this.newFormAdd.reset();
            this._toastrService.clear();
            this._toastrService.success(data.message, 'Success!', { toastClass: 'toast ngx-toastr', closeButton: true });
            this.progressMainTable = true;
            this.stocksList(this.page, this.lengths);
          }
          else {
            this.error = data.error;
          }
        },
        err => {
          if (err.error.error == 'Unauthenticated.') {
            this._authenticationService.logout();
            this._router.navigate(['/login']);
          }
        });
    }
  }

  stocksList(my_start: any, my_lengths: any) {
    const formdata = new FormData();
    formdata.append('start', my_start);
    formdata.append('length', my_lengths);
    this.stockreceiveService.getData(formdata).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.stockList = response.data;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }
  stocksListNew(my_start: any, my_lengths: any, type: any = 0) {
    const formdata = new FormData();
    if (type != 1) {
      formdata.append('start', my_start);
    }
    else {
      formdata.append('start', '0');
      this.page = 0;
      this.pageBasicText = 1;
    }
    formdata.append('length', my_lengths);
    if (type != 1) {
      if (this.fr.start_date.value !== null) {
        formdata.append('start_date', this.fr.start_date.value);
      }
      if (this.fr.end_date.value !== null) {
        formdata.append('end_date', this.fr.end_date.value);
      }
      if (this.fr.vendor_id.value != "") {
        formdata.append('vendor_id', this.fr.vendor_id.value);
      }
      if (this.fr.vehicle_details.value != "") {
        formdata.append('vehicle_details', this.fr.vehicle_details.value);
      }
    }
    this.stockreceiveService.getData(formdata).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.stockList = response.data;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }
  reloadList(type: any = 0) {
    this.progressMainTable = true;
    this.stocksListNew(this.page, this.lengths, type);
  }

  loadPage(event: any) {
    this.progressMainTable = true;
    this.page = this.lengths * (event - 1);
    this.stocksListNew(this.page, this.lengths);
  }
  loadPageLenghs(event: any) {
    this.progressMainTable = true;
    this.lengths = event.target.value;
    this.stocksListNew(this.start, this.lengths);
  }

  details(stock_data: any, modalSM) {
    this.modalService.open(modalSM, {
      centered: true,
      size: 'xl'
    });
    this.exp_name = stock_data.vendor_name;
    this.stockreceiveService.getmeta(stock_data.id).subscribe(
      data => {
        this.isModelLoading = false;
        if (data.status) {
          this.purchaseDetails = data.data;
        } else {
          this._toastrService.error(data.errorMessage, 'Error!');
        }
      },
      err => {
        this._toastrService.error(err.errorMessage, 'Opps!');
      }
    );
  }

  orderchangeStatus(orderId: any, status: any,name) {

    switch (status) {
      case 0:
        this.StatusLable = 'Pending';
        break;
      case 1:
        this.StatusLable = 'In Transit';
        break;
      case 2:
        this.StatusLable = 'Received';
        break;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want to change.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, go ahead.',
      cancelButtonText: 'No, let me think'
    }).then((result) => {
      if (result.value) {
        if (status == 3) {
          this.purchaseId = orderId;
          this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
        } else {
          this.stockreceiveService.orderchangeStatus(orderId, status).subscribe(
            data => {
              if (data.status) {
                this.reloadList();
                this._toastrService.success(data.message, 'Success!', { toastClass: 'toast ngx-toastr', closeButton: true });
              }
              else {
                this._toastrService.error(data.errorMessage, 'Opps!', { toastClass: 'toast ngx-toastr', closeButton: true });
              }
            },
            err => {
              if (err.error.error == 'Unauthenticated.') {
                this._authenticationService.logout();
                this._router.navigate(['/login']);
              }
              this._toastrService.error(err.errorMessage, 'Opps!', { toastClass: 'toast ngx-toastr', closeButton: true });
            }
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Stock Status Not Changed',
          'error'
        )
      }
    })
  }

  edit(index: any) {
    this.purchaseId = this.stockList[index].id;
    this.fd.port_date.setValue(this.stockList[index].port_date_e);
    
    this.toggleSidebar("new-sidebar-date", this.purchaseId);
  }
}
